export const PRIVACY_POLICY = 'https://www.cian.ru/legal-documents/politika_konfidencialnosti_0';
export const CONSENT_PERSONAL_DATA =
  'https://cdn.cian.site/frontend/info-assets/cpd/soglasheniye_na_obrabotku_perdata.docx';
